import { render } from "./DeleteBillingAddress.vue?vue&type=template&id=1c94e600&scoped=true&bindings={\"id\":\"props\",\"userId\":\"props\",\"addressInUse\":\"options\",\"cancel\":\"options\",\"deleteBillingAddress\":\"options\"}"
import script from "./DeleteBillingAddress.vue?vue&type=script&lang=js"
export * from "./DeleteBillingAddress.vue?vue&type=script&lang=js"

import "./DeleteBillingAddress.vue?vue&type=style&index=0&id=1c94e600&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c94e600"

export default script